import { ioGetCompanyBranches } from '@/febos/servicios/api/empresas.api';
import {
  batchesList,
  createBatch,
  updateBatch,
  updateStatusBatch,
  updateBatchEspecificData
} from '@/febos/servicios/api/aduanas/batches.api';
import { listOptions } from '@/febos/servicios/api/opciones.api';

export const fetchBatchesList = async ({ commit }, data) => {
  try {
    commit('SET_BATCHES_LIST', {});
    commit('SET_LOADING', true);
    const response = await batchesList(data);
    commit('SET_BATCHES_LIST', response.data);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const fetchCompanyBranches = async ({ commit, rootGetters }) => {
  commit('SET_LIST_LOADING', { target: 'companyBranches', value: true });
  commit('SET_LIST', { target: 'companyBranches', value: [] });
  const { data: { sucursales: branches } } = await ioGetCompanyBranches(
    {
      empresaId: rootGetters['Empresas/companyId'],
      simular: 'no',
      pagina: 1,
      filas: 1000
    }
  );
  commit('SET_LIST', { target: 'companyBranches', value: branches });
  commit('SET_LIST_LOADING', { target: 'companyBranches', value: false });
};
export const fetchLegalQualities = async ({ commit }) => {
  commit('SET_LIST_LOADING', { target: 'legalQualities', value: true });
  commit('SET_LIST', { target: 'legalQualities', value: [] });
  const response = await listOptions({
    grupoOpcion: 'calidad-juridica-aduanas',
    deshabilitado: 'no'
  });
  commit('SET_LIST', { target: 'legalQualities', value: response.data.opciones });
  commit('SET_LIST_LOADING', { target: 'legalQualities', value: false });
};
export const fetchBatchClassification = async ({ commit }) => {
  commit('SET_LIST_LOADING', { target: 'batchClassification', value: true });
  commit('SET_LIST', { target: 'batchClassification', value: [] });
  const response = await listOptions({
    grupoOpcion: 'io.aduanas.productos',
    deshabilitado: 'no'
  });
  commit('SET_LIST', { target: 'batchClassification', value: response.data.opciones });
  commit('SET_LIST_LOADING', { target: 'batchClassification', value: false });
};
export const selectBatchState = ({ commit }, batch) => {
  commit('SET_SELECTED_BATCH', batch);
};

export const selectAllElements = ({ commit }, isSelected) => {
  commit('MARK_SELECTED_BATCHES', isSelected);
};

export const attemptProcessBatch = async ({ commit }, batch) => {
  try {
    commit('SET_LOADING', true);
    const response = await createBatch(batch);
    commit('ADD_BATCH', response);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const attemptUpdateBatch = async ({ commit }, batch) => {
  try {
    commit('SET_LOADING', true);
    const response = await updateBatch(batch);
    if (batch.params?.simular !== 'si') {
      commit('UPDATE_BATCH', response.data.lote);
    }
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const attemptUpdateStatusBatch = async ({ commit }, { batchId, action }) => {
  try {
    commit('SET_LOADING', true);
    const response = await updateStatusBatch({ batchId, action });
    commit('UPDATE_BATCH_LIST_STATUS', response.data);
    return response;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const attemptUpdateBatchEspecificData = async ({ commit }, batch) => {
  try {
    commit('SET_LOADING', true);
    const response = await updateBatchEspecificData(batch);
    commit('UPDATE_BATCH', response.data.lote);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};
